import styled from 'styled-components';
import { Body, Caption, H3 } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import DefaultStatus from 'components/Status';
import IconOrder from 'assets/icons/orders.svg?react';
import IconTicket from 'assets/icons/ticket.svg?react';
import {
  FiMapPin as IconLocation,
  FiKey as IconKey,
  FiUser as IconUser,
  FiWifi as IconWifi,
} from 'react-icons/fi';
import DefaultSelect from './Select';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1.5rem;
`;

export const RestaurantInfo = styled.div``;
export const PrinterSettings = styled.div``;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 2.5rem 2rem;
  border-radius: 1.5rem;
`;

export const Row = styled.div`
  min-height: 3rem;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  :last-child {
    margin-bottom: 0;
  }
`;

export const Title = styled(H3)`
  margin-bottom: 1rem;
`;

export const WrapIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  height: 2rem;
  width: 2rem;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.iconGray};
`;

export const OrderIcon = styled(IconOrder)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const LocationIcon = styled(IconLocation)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const KeyIcon = styled(IconKey)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const UserIcon = styled(IconUser)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const WifiIcon = styled(IconWifi)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const TicketIcon = styled(IconTicket)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const WrapText = styled.div``;

export const CardTitle = styled(Body)`
  font-weight: 600;
  width: 50%;
`;

export const CardText = styled(Body)`
  width: 50%;
`;

export const Status = styled(DefaultStatus)`
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.5625rem;
`;

export const FloatStatus = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  margin-left: 16rem;
`;

export const FloatSelect = styled(FloatStatus)`
  margin-top: -0.625rem;
`;

export const WrapTicket = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const SmallText = styled(Caption)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  text-align: center;
`;

export const GreenText = styled(Body)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greenDark};
  cursor: pointer;
`;

export const Text = styled(Body)``;

export const Select = styled(DefaultSelect)``;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonTestPrinter = styled.button`
  border: none;
  background: none;
`;
